import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import Step1 from './PaymentSteps/Step1';
import Step2 from './PaymentSteps/Step2';
import Step3 from './PaymentSteps/Step3';

const PaymentData = ({
  onSubmit,
  amount,
  recurrence,
  campaign,
  foundation,
}) => {
  const [step, setStep] = useState(1);
  const [userId, setUserId] = useState(null);
  const [formData, setFormData] = useState({});
  const {
    control,
    handleSubmit,
    formState: { errors },
    trigger,
    setValue,
    watch,
  } = useForm();

  const nextStep = async () => {
    const valid = await trigger();
    if (valid) {
      setStep(step + 1);
    }
  };

  const prevStep = () => {
    setStep(step - 1);
  };
  const updateFormData = (data) => {
    setFormData((prevData) => ({
      ...prevData,
      ...data,
    }));
  };
  const handlePayment = (data) => {
    onSubmit({
      ...formData, // Datos acumulados de los pasos anteriores
      ...data, // Datos finales
      amount,
      recurrence,
      userId,
      foundation,
      campaign,
    });
  };
  const formProps = {
    control,
    errors,
    setValue,
    trigger,
    watch,
  };
  const paymentData = {
    recurrence,
    userId,
    foundation,
    campaign,
    amount,
  };

  return (
    <form
      onSubmit={handleSubmit(handlePayment)}
      className='payment-data'>
      {step === 1 && (
        <Step1
          control={control}
          errors={errors}
          onNext={nextStep}
        />
      )}
      {step === 2 && (
        <Step2
          formProps={formProps}
          onPrev={prevStep}
          onNext={nextStep}
          setUserId={setUserId}
        />
      )}
      {step === 3 && (
        <Step3
          formProps={formProps}
          onPrev={prevStep}
          onSubmit={handleSubmit((data) => {
            updateFormData(data);
            handlePayment(data); // Llamar la función de pago con todos los datos acumulados
          })}
          paymentData={paymentData}
        />
      )}
    </form>
  );
};

export default PaymentData;
